/**
 * Commercial amount boundary.
 *
 * blank / null / undefined = unknown
 * 0 = intentional zero
 * finite number = known amount
 *
 * Unknown must stay unknown. It is not coerced to 0 here.
 */

export function readCommercialAmount(value) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  if (value == null) return null;

  const trimmed = String(value).trim();
  if (!trimmed) return null;

  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatCommercialAmount(amount) {
  if (amount == null || amount === "") return "—";

  const parsed =
    typeof amount === "number" ? amount : Number(String(amount).trim());

  if (!Number.isFinite(parsed)) return "—";

  return `$${parsed.toFixed(2)}`;
}

/**
 * Sum known amounts. Any unknown or non-finite member makes the whole
 * sum unknown so a missing price cannot masquerade as zero.
 */
export function sumCommercialAmounts(amounts) {
  let total = 0;

  for (const amount of amounts || []) {
    if (amount == null || !Number.isFinite(Number(amount))) {
      return null;
    }
    total += Number(amount);
  }

  return total;
}

export function parseOptionalNonNegativeAmount(value, label) {
  if (value == null || String(value).trim() === "") {
    return { value: null };
  }

  const parsed = readCommercialAmount(value);
  if (parsed == null || parsed < 0) {
    return { error: `Enter a valid ${label}, or leave it blank.` };
  }

  return { value: parsed };
}

export function commercialInputValue(value) {
  if (value == null) return "";
  return String(value);
}
